import { createClient } from '@supabase/supabase-js';

// ─────────────────────────────────────────────────────────────────────────────
// Supabase credentials.
// IMPORTANT: These are HARDCODED for production reliability.
// The ANON key is safe to expose client-side — it is a JWT with role=anon.
// Security is enforced entirely by Row-Level Security policies in the DB.
// NEVER put the SERVICE_ROLE key here.
// ─────────────────────────────────────────────────────────────────────────────
const SUPABASE_URL = 'https://zbmdvvycinovkysrmfsj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpibWR2dnljaW5vdmt5c3JtZnNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYxMzQwNTEsImV4cCI6MjA5MTcxMDA1MX0.j6Wwss76UhVMnSdVT5Qt101NY2EV_B5qGo8EqG3NEgM';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase credentials');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});